module.exports = __webpack_public_path__ + "static/media/uk.bc48afcc.svg";